// Wire contract — imports history RESPONSE schemas. One run row mirrors
// import_jobs (+ the Tier-1 actor resolved via the shared correlation_id);
// the per-row detail mirrors import_job_rows.
import { z } from 'zod';
import { paginatedResponseSchema } from '../common/pagination.js';
import { ImportFormatSchema, ImportOperationSchema, ImportRowChangeSchema, ImportRowErrorSchema } from '../import-export/envelopes.js';
export const ImportJobListItemSchema = z
    .object({
    id: z.string().max(16),
    created_at: z.string(), // ISO
    completed_at: z.string().nullable(),
    entity_type: z.string().max(64),
    operation: ImportOperationSchema,
    status: z.enum(['running', 'committed', 'failed']),
    format: ImportFormatSchema,
    filename: z.string().max(255),
    total_rows: z.number().int().nonnegative(),
    provisioned: z.boolean(), // the run created missing vocabulary values (ADR-059 §7)
    create_count: z.number().int().nonnegative(),
    update_count: z.number().int().nonnegative(),
    skip_count: z.number().int().nonnegative(),
    error_count: z.number().int().nonnegative(),
    // The Tier-1 `import_started` actor (via correlation_id); null when the
    // audit row is gone or the run predates it.
    actor: z.object({ id: z.string(), label: z.string() }).nullable(),
})
    .strict();
export const ImportsListResponseSchema = paginatedResponseSchema(ImportJobListItemSchema);
// Detail = the list row + the run metrics (nullable until terminal).
export const ImportJobDetailSchema = ImportJobListItemSchema.extend({
    parse_ms: z.number().int().nullable(),
    validate_ms: z.number().int().nullable(),
    commit_ms: z.number().int().nullable(),
    peak_memory_bytes: z.number().int().nullable(),
}).strict();
export const ImportJobRowItemSchema = z
    .object({
    row_number: z.number().int().nonnegative(), // 0 = a file-level finding (no source row)
    outcome: z.enum(['create', 'update', 'skip', 'error']),
    entity_id: z.string().nullable(),
    match_key_value: z.string().nullable(),
    errors: z.array(ImportRowErrorSchema).nullable(),
    // What the row actually wrote — re-read from the run's Tier-1 audit rows
    // (shared correlation_id), never duplicated into the run tables.
    changes: z.array(ImportRowChangeSchema).nullable(),
})
    .strict();
export const ImportRowsResponseSchema = paginatedResponseSchema(ImportJobRowItemSchema);
